/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const PrintAltIconConfig = {
  name: 'PrintAltIcon',
  height: 1024,
  width: 1024,
  svgPath: 'M219.429 877.714h585.143v-146.286h-585.143v146.286zM960 658.286h-896c-35.2 0-64-28.8-64-64v-310.857c0-35.2 28.798-64 64-64h155.429v-219.429h585.143v219.429h155.429c35.2 0 64 28.8 64 64v310.857c0 35.2-28.8 64-64 64zM731.429 73.143h-438.857v292.571h438.857v-292.571zM959.925 550.018c0-25.625-20.777-46.4-46.402-46.4s-46.402 20.775-46.402 46.4 20.777 46.4 46.402 46.4c25.63 0 46.402-20.775 46.402-46.4z',
  yOffset: '64',
  xOffset: '',
  transform: 'rotate(180 0 512) scale(-1 1)'
};
export default createIcon(PrintAltIconConfig);
//# sourceMappingURL=print-alt-icon.js.map